import { BRAND_Q } from './brandQuestions';

export const STRATEGY_SECTIONS = [
  { key: 'growth', title: 'Goals & services', dbSections: ['Growth', 'Practice Setup'] },
  { key: 'patients', title: 'Your patients', dbSections: ['Your Patients'] },
  { key: 'budget', title: 'Budget & history', dbSections: ['Marketing', 'Additional'] },
] as const;

export type SectionKey = (typeof STRATEGY_SECTIONS)[number]['key'];

export const ARCHETYPE_Q_KEYS = BRAND_Q.map((q) => q.questionKey);
